import styled from 'styled-components';
import { PasswordValidationInfo } from '../../../common/iam/users/password-validation';
import { BouColor } from '../../common/generic/global/bou-colors';
import { LoginHintContainer } from './shared';

export const PasswordValidationInfoText = (props: {
  validatedPassword: PasswordValidationInfo;
  passwordFieldLeft: boolean;
  noUserNameAsked?: boolean;
}) => {
  const { validatedPassword, passwordFieldLeft } = props;
  return (
    <LoginHintContainer>
      The password must be{' '}
      <PasswordRule {...{ valid: validatedPassword.minLength, passwordFieldLeft }}>
        at least 8 characters long
      </PasswordRule>
      , and contain at least{' '}
      <PasswordRule {...{ valid: validatedPassword.minLowercase, passwordFieldLeft }}>
        1 lowercase character
      </PasswordRule>
      ,{' '}
      <PasswordRule {...{ valid: validatedPassword.minUppercase, passwordFieldLeft }}>
        1 uppercase character
      </PasswordRule>
      , <PasswordRule {...{ valid: validatedPassword.minSymbols, passwordFieldLeft }}>1 special character</PasswordRule>
      , and <PasswordRule {...{ valid: validatedPassword.minNumbers, passwordFieldLeft }}>1 number</PasswordRule>.
      {!validatedPassword.notSameAsEmailOrUsername && (
        <PasswordRule {...{ valid: false, passwordFieldLeft }}>
          {' '}
          The password cannot be the same as {props.noUserNameAsked ? '' : 'the username or'} the email address.
        </PasswordRule>
      )}
    </LoginHintContainer>
  );
};
const PasswordRule = styled.span<{ valid: boolean | undefined; passwordFieldLeft: boolean }>`
  ${props =>
    props.valid === false && props.passwordFieldLeft
      ? `
    color: ${BouColor.TOOL_TEXT_ERROR_RED};
  `
      : ''}
`;
